import React from 'react'
import {Icon} from '@chakra-ui/react'
const DeleteIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" id="delete" {...props}>
            <path d="M14 9H16V19H14V9Z" fill="black" />
            <path d="M10 9H8V19H10V9Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 4V0H8V4H1V6H3V24H21V6H23V4H16ZM5 6V22H19V6H5ZM10 2V4H14V2H10Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default DeleteIcon
